import { useState } from "react";
import Reveal from "@/components/Reveal";
import { faqs } from "@/mocks/site";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Reveal>
              <div className="lg:sticky lg:top-24">
                <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.24em] text-secondary-600">
                  <span className="h-px w-8 bg-secondary-400"></span> Guide · 吃瓜指南
                </p>
                <h2 className="mt-3 font-heading text-2xl font-black leading-tight tracking-tight text-foreground-900 md:text-[34px]">
                  吃瓜前，
                  <br />
                  先弄清这些事
                </h2>
                <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                  关于可信度、栏目定义、投稿方式与隐私边界，这里有一份简明指南。常看常新，帮你当一个清醒的吃瓜人。
                </p>
                <div className="mt-6 inline-flex items-center gap-2 rounded-xl border border-background-200 bg-background-100 px-4 py-3">
                  <i className="text-xl text-primary-500 ri-shield-check-line" aria-hidden="true"></i>
                  <span className="text-sm text-foreground-700">
                    可信分级：<strong className="text-foreground-900">实锤度高 · 多方互证 · 网传中 · 纯属推测</strong>
                  </span>
                </div>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="flex flex-col gap-3">
              {faqs.map((f, i) => {
                const isOpen = open === i;
                return (
                  <Reveal key={i} delay={i * 40}>
                    <div
                      className={`overflow-hidden rounded-2xl border transition-colors ${
                        isOpen ? "border-primary-200 bg-background-100" : "border-background-200 bg-background-50"
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => setOpen(isOpen ? -1 : i)}
                        className="flex w-full items-center gap-3 px-5 py-4 text-left"
                        aria-expanded={isOpen}
                      >
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-black ${
                            isOpen ? "bg-primary-500 text-background-50" : "bg-primary-100 text-primary-800"
                          }`}
                        >
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        <span className="flex-1 text-[15px] font-semibold text-foreground-900">{f.q}</span>
                        <i
                          className={`shrink-0 text-lg text-primary-600 transition-transform duration-300 ${
                            isOpen ? "ri-subtract-line" : "ri-add-line"
                          }`}
                          aria-hidden="true"
                        ></i>
                      </button>
                      <div
                        className={`grid transition-all duration-300 ease-out ${
                          isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                        }`}
                      >
                        <div className="overflow-hidden">
                          <p className="px-6 pb-5 pl-[4.5rem] pr-8 text-sm leading-[1.9] text-foreground-600 md:pl-14">
                            {f.a}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}